import { updateState } from 'redux_new/handlers'
import { createReducer } from '../handlers'
import types from './types'

const initialState = {
  isOpen: false,
  isLoading: false,
  companyResources: [],
  resourcesToDownload: [],
}

const displayResources = (state, action) => {
  const { isOpen, isLoading } = action
  return updateState(state, { isOpen, isLoading })
}

const getResources = (state, action) => {
  const { companyResources } = action
  return updateState(state, { isLoading: false, companyResources })
}

const handleSelectResourcesToDownload = (state, action) => {
  const { resourcesToDownload } = action
  return updateState(state, { resourcesToDownload })
}

export default createReducer(initialState, {
  [types.UPDATE_RESOURCES]: getResources,
  [types.DISPLAY_RESOURCES]: displayResources,
  [types.SELECT_RESOURCES_TO_DOWNLOAD]: handleSelectResourcesToDownload
})